import { Api, IConfig } from 'elc-service';

export interface IQuizResult {
    data: IVtoQuizData;
}

export interface IVtoQuizData {
    quizId: string;
    results: IQuizResultData[];
}

export interface IQuizResultData {
    product_benefit_type: string;
    product_id: string;
    crosssell_content_1: number;
    extra_care: number;
    skin_diagrams: number;
    skincare_regimen: number;
    tips: number;
}

export interface IQuizParam {
    queryParams: {
        face_concern: string[];
        eye_concern: string[];
        skin_type: string;
    };
}

export class QuizApiSdk extends Api {
    private apiBasePath: string;

    constructor(configStore: IConfig) {
        super(configStore);
        this.apiBasePath = 'stardust-foundation-quiz-v0';
    }

    public async getQuizDataByQuizId(param: IQuizParam, quizId: string): Promise<IVtoQuizData> {
        const url = `/${this.apiBasePath}/quiz/${quizId}/query`;
        const response: IQuizResult = await this.httpTransport.post({
            url: url,
            body: param
        });

        return response.data;
    }
}
